import React, { FC } from 'react';
import { Input } from 'components/atoms/input';

export const EditSpace: FC<{
  spaceId: number;
  spaceName: string;
  cancelEdit(): void;
  onUpdate(spaceName: string): void;
}> = (props) => {
  const { spaceId, spaceName, cancelEdit, onUpdate } = props;

  const update = (_spaceName) => {
    onUpdate(_spaceName);
  };
  const handleOnEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    update(e.currentTarget.value);
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === 27) {
      cancelEdit();
    }
  };

  const handleOnBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    update(e.currentTarget.value);
  };

  return (
    <Input
      key={spaceId}
      autoFocus
      size="small"
      type="text"
      defaultValue={spaceName}
      data-cy={`space_${spaceName}.input`}
      onBlur={handleOnBlur}
      onPressEnter={handleOnEnter}
      onKeyDown={handleOnKeyDown}
      onClick={(e) => e.stopPropagation()}
    />
  );
};
